import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUserStr = sessionStorage.getItem('currentUser');
    const usuario = sessionStorage.getItem('usuario');

    if (currentUserStr) {
      try {
        const currentUser = JSON.parse(currentUserStr);
        if (currentUser && currentUser.token) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${currentUser.token}`,
              Iduser: usuario || '',
            },
          });
        }
      } catch (error) {
        // Si el storage se corrompe, no bloqueamos el request (solo log para debug)
        // eslint-disable-next-line no-console
        console.error('Error al parsear currentUser del sessionStorage:', error);
      }
    }

    return next.handle(request);
  }
}
